// extracted by mini-css-extract-plugin
module.exports = {"defaultShiftTime":"DefaultShiftTime_defaultShiftTime__Trl61"};